module.exports = __webpack_public_path__ + "img/information.ddbf1e3a.svg";